import {
    Box,
    Flex,
    Text,
    Button,
    Icon,
    HStack,
} from "@chakra-ui/react";
import { FiList, FiInfo } from "react-icons/fi";
import Navbar from "../../Components/Navbar/Navbar";
import Sidebar from "../../Components/Sidebar";

const SystemUpdate = () => {
    const SIDEBAR_WIDTH = "240px";

    return (
        <>
            <Navbar />
            <Sidebar />
            <Box
                p={{ base: 4, md: 8 }}
                bg="gray.50"
                minH="100vh"
                mt="64px"
                ml={{ base: 0, md: SIDEBAR_WIDTH }}
            >
                {/* HEADER */}
                <Flex
                    mb={8}
                    justify="space-between"
                    align="center"
                    direction={{ base: "column", md: "row" }}
                    gap={4}
                >
                    <Text fontSize="2xl" fontWeight="semibold" color="gray.700">
                        System Updates
                    </Text>
                    <Button
                        leftIcon={<Icon as={FiList} />}
                        variant="outline"
                        color="#4f46e5"
                        borderColor="#4f46e5"
                        bg="white"
                        size="md"
                        _hover={{ bg: "blue.50" }}
                    >
                        Update Log
                    </Button>
                </Flex>

                {/* VERSION CARD */}
                <Flex justify="center" mt={12}>
                    <Box
                        bg="white"
                        p={{ base: 8, md: 16 }}
                        borderRadius="xl"
                        border="2px solid"
                        borderColor="green.400"
                        maxW="800px"
                        w="100%"
                        textAlign="center"
                        position="relative"
                    >
                        <Text
                            fontSize={{ base: "7xl", md: "9xl" }}
                            fontWeight="bold"
                            color="orange.400"
                            lineHeight="1"
                        >
                            4.0
                        </Text>
                        <Text
                            fontSize={{ base: "2xl", md: "4xl" }}
                            fontWeight="medium"
                            color="orange.400"
                            mb={10}
                        >
                            Your Version
                        </Text>

                        <HStack align="start" spacing={3} textAlign="left" px={{ base: 0, md: 4 }}>
                            <Icon as={FiInfo} color="blue.400" boxSize={6} mt={1} />
                            <Text color="gray.600" fontSize="md" fontStyle="italic">
                                <Text as="span" fontWeight="bold">
                                    You are currently using the latest version of the system.
                                </Text>{" "}
                                We are committed to continuous improvement and are actively developing
                                the next version. Stay tuned for exciting new features and
                                enhancements to be released soon!
                            </Text>
                        </HStack>
                    </Box>
                </Flex>
            </Box>
        </>
    );
};

export default SystemUpdate;
